module.exports = __webpack_public_path__ + "img/fi-rr-angle-small-right.bc86d7c6.svg";